import { L, inputCls, money } from "./common";

const m4 = (v) => `$${(v || 0).toFixed(4)}`;

function LandedSplit({ f, set, it }) {
  const adj = it.landed_adjustment || 0;
  const base = Number(f.base_unit_cost) || 0;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2" data-testid="fact-landed-split">
      <L label="BASE VENDOR UNIT COST ($)" hint="Supplier price per unit">
        <input type="number" step="any" min="0" data-testid="fact-base_unit_cost" className={`${inputCls} font-mono`} value={f.base_unit_cost ?? ""} onChange={(e) => set("base_unit_cost", e.target.value)} /></L>
      <div className="p-3 rounded-md bg-[#090D16] border border-[#1E293B]" data-testid="fact-landed-adjustment" data-tip="Freight and fees allocated per unit by PO receipts">
        <div className="font-mono text-[10px] tracking-[0.15em] text-[#6B7280]">ALLOCATED LANDED COST ADJ.</div>
        <div className="font-mono font-bold text-[#A78BFA]">+{m4(adj)}</div>
      </div>
      <div className="p-3 rounded-md bg-[#090D16] border border-[#1E293B]" data-testid="fact-landed-total">
        <div className="font-mono text-[10px] tracking-[0.15em] text-[#6B7280]">LANDED UNIT COST</div>
        <div className="font-mono font-bold text-[#38BDF8]">{m4(base + adj)}</div>
      </div>
    </div>
  );
}

export function ManualCost({ f, set, pol, hint, it }) {
  const on = !!f.manual_cost_override;
  return (
    <div className={`p-3 rounded-md border space-y-2 ${on ? "border-[#A78BFA]" : "border-[#1E293B]"}`} data-testid="fact-manual-cost">
      {pol?.cost_override_allowed ? (
        <label className="flex items-center gap-2 text-sm cursor-pointer">
          <input type="checkbox" data-testid="fact-manual-cost-override" className="w-5 h-5 accent-[#A78BFA]" checked={on} onChange={(e) => set("manual_cost_override", e.target.checked)} />
          Manual Cost Override {on && <span className="font-mono text-[10px] font-bold text-[#C4B5FD]">LOCKED</span>}
        </label>
      ) : <div className="font-mono text-[10px] text-[#6B7280]">Manual override not enabled for Tier {f.tier} (Master Controls)</div>}
      {f.tier === 1 && it && <LandedSplit f={f} set={set} it={it} />}
      {f.tier === 1 && <div className="text-[11px] text-[#6B7280]">{hint}</div>}
      {on && <L label="CUSTOM UNIT COST ($)" hint="Locked: PO receiving will not change this cost">
        <input type="number" step="any" data-testid="fact-unit_cost" className={`${inputCls} font-mono`} value={f.unit_cost ?? ""} onChange={(e) => set("unit_cost", e.target.value)} /></L>}
    </div>
  );
}

export default function FactSheetCostingTab({ it, ext, onToggle, price, f, set, pol }) {
  const cb = it.cost_breakdown;
  const pending = (it.production_type === "external") !== ext;
  const manual = it.manual_cost_override && pol?.cost_override_allowed;
  return (
    <div className="p-4 rounded-md border border-[#1E293B] space-y-3" data-testid="fact-cost-block">
      <label className="flex items-center gap-2 text-sm cursor-pointer">
        <input type="checkbox" data-testid="fact-external-checkbox" className="w-5 h-5 accent-[#F59E0B]" checked={ext} onChange={(e) => onToggle(e.target.checked)} />
        Externally produced (outsourced)
      </label>
      <div className="text-[11px] text-[#6B7280]">{ext ? "Labor = outsourced piece rate on the BOM. Not counted against shop capacity." : "Labor = internal labor rate (Master Controls) × production time."}{pending && <span className="text-[#F59E0B]"> Save to recalculate.</span>}</div>
      {!cb || cb.has_bom === false ? (
        <div className="text-sm text-[#F59E0B]" data-testid="fact-cost-no-bom">UNIT COST $0.00 · No BOM. Create one to calculate cost.</div>
      ) : (
        <div className="grid grid-cols-3 gap-2 font-mono">
          {[["MATERIALS", cb.materials, "materials"], [cb.labor_type === "external" ? "PIECE RATE" : `LABOR @ $${cb.labor_rate ?? 0}/H`, cb.labor, "labor"], ...(cb.machine_name ? [[`${cb.machine_name.toUpperCase()} @ $${cb.machine_rate}/H`, cb.machine, "machine"]] : []), ["UNIT COST", cb.total, "total"]].map(([l, v, k]) => (
            <div key={k} className="p-3 rounded-md bg-[#090D16] border border-[#1E293B]" data-testid={`fact-cost-${k}`}>
              <div className="text-[10px] tracking-[0.15em] text-[#6B7280]">{l}</div>
              <div className={`font-bold ${k === "total" ? "text-xl text-[#38BDF8]" : "text-base"}`}>{money(v)}</div>
            </div>
          ))}
        </div>
      )}
      {price > 0 && cb?.has_bom && <div className="font-mono text-[11px] text-[#10B981]" data-testid="fact-margin">MARGIN {(100 * (1 - (manual ? it.unit_cost : cb.total) / price)).toFixed(0)}% AT {money(price)}</div>}
      {manual && <div className="font-mono text-[11px] text-[#C4B5FD]" data-testid="fact-cost-manual-active">MANUAL UNIT COST {money(it.unit_cost)} IN USE · BOM VALUE {money(cb?.total)}</div>}
      <div className="text-[10px] text-[#6B7280]">Calculated from the BOM unless Manual Cost Override is on.</div>
      {(pol?.cost_override_allowed || it.manual_cost_override) && <ManualCost f={f} set={set} pol={pol} />}
    </div>
  );
}
